module.exports = {"de":{"displayLabel":"Deutsch","files":{"messageBundle":"de.json"}},"en":{"displayLabel":"English (U.S.)","files":{"messageBundle":"en.json"}},"fr":{"displayLabel":"Français","files":{"messageBundle":"fr.json"}},"es":{"displayLabel":"Español","files":{"messageBundle":"es.json"}},"ja":{"displayLabel":"日本語","files":{"messageBundle":"ja.json"}}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/manifest.json
// module id = 1037
// module chunks = 5